import { render } from "./RiBtnAdd.vue?vue&type=template&id=1ba26c32"
import script from "./RiBtnAdd.vue?vue&type=script&lang=js"
export * from "./RiBtnAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBtnAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ba26c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ba26c32', __exports__)) {
    api.reload('1ba26c32', __exports__)
  }
  
  module.hot.accept("./RiBtnAdd.vue?vue&type=template&id=1ba26c32", () => {
    api.rerender('1ba26c32', render)
  })

}


export default __exports__